import { Fragment, useState } from "react";
import { Tooltip } from "reactstrap";

function InfoTooltip(props) {

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <div>
      <a href="#" className="tooltip-contain" id={props.id}>
        {props.title}
      </a>
      <Tooltip
        placement="right"
        isOpen={tooltipOpen}
        autohide={false}
        target={props.id}
        toggle={toggle}
      >
        {props.text}
      </Tooltip>
    </div>
  );
}

export default InfoTooltip;
